module.exports = __webpack_public_path__ + "img/pieton.08a3ea20.jpg";